import React from "react";
import { Zap, ShieldCheck, Layers, TrendingUp, Server, Lock } from "lucide-react";
import PageHero from "@/components/public/PageHero";

const COND = [
  { Icon: Zap, title: "Ultra-Low Latency", desc: "Order execution engineered for consistency, targeting sub-10ms speeds via co-located servers." },
  { Icon: ShieldCheck, title: "Segregated Client Funds", desc: "Client capital is held separately with tier-1 banking partners, ring-fenced from company funds." },
  { Icon: Layers, title: "Deep Aggregated Liquidity", desc: "Pricing aggregated from multiple institutional providers for tight, stable spreads." },
  { Icon: TrendingUp, title: "Transparent Pricing", desc: "Raw interbank spreads with clearly disclosed commissions — no hidden markups." },
  { Icon: Server, title: "Robust Infrastructure", desc: "Redundant systems designed for high availability during peak market activity." },
  { Icon: Lock, title: "Data Security", desc: "Encryption in transit and at rest, with strict access controls across all systems." },
];

export default function Conditions() {
  return (
    <div>
      <PageHero overline="Why Cresent" title="Institutional-Grade Trading Conditions" subtitle="Built for traders who demand transparency, speed and security." />
      <section className="py-16 sm:py-24 bg-white">
        <div className="cb-container grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {COND.map((c) => (
            <div key={c.title} className="cb-card p-8" data-testid={`conditions-${c.title.toLowerCase().replace(/\s+/g, "-")}`}>
              <c.Icon className="gold-text mb-4" size={30} />
              <h3 className="text-[#0B1D40] font-semibold text-lg mb-2">{c.title}</h3>
              <p className="text-slate-500 text-sm leading-relaxed">{c.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
